import React from 'react';
import PropTypes from 'prop-types';
import css from './Course.css';
import Title from 'common/Title';
import LinkButton from "../../../SF/LinkButton";
import { getWord } from "utils/tenant";
import { isEmpty } from 'lodash';

export default class Course extends React.Component {

  onClick(callback, e) {
    if ( e ) e.preventDefault(); // Prevent errors on tests
    callback();
    return false;
  }

  get courseLink() {
    if (!this.props.canChangeCourse) {
      return null;
    }

    if(!this.props.courseName)
      return <LinkButton className={'add-course'}
                         onClick={this.onClick.bind(this, this.props.onAddCourseClicked)}>
        {`Add a ${getWord('course', true)}`}
      </LinkButton>;

    return this.props.onAddCourseClicked ?
      <LinkButton className={css['change-course']}
                  onClick={this.onClick.bind(this, this.props.onAddCourseClicked)}
                  aria-label={`Change ${getWord('course', true)}`}>
        Change
      </LinkButton> : null;
  }

  get clearLink() {
    if ( !this.props.clearable || isEmpty(this.props.courseName) ) return null;
    return (
      <LinkButton
        className={css['clear-course']}
        onClick={this.onClick.bind(this, this.props.onClearCourseClicked)}
        aria-label={`Clear ${getWord('course', true)}`}>
        Clear
      </LinkButton>
    );
  }

  render() {
    return (
      <div>
        <Title text={getWord('course')} />
        <div className={css['text']}>
          <div>
            <span>{this.props.courseName}</span>
            {this.courseLink}
            <div>{this.clearLink}</div>
          </div>
        </div>
      </div>
    );
  }
}

Course.defaultProps = {
  clearable: false
};

Course.propTypes = {
  courseName: PropTypes.string,
  canChangeCourse: PropTypes.bool,
  onAddCourseClicked: PropTypes.func,
  clearable: PropTypes.bool,
  onClearCourseClicked: PropTypes.func
};
